import { render, staticRenderFns } from "./cloundorderlist.vue?vue&type=template&id=49585bc0&scoped=true"
import script from "./cloundorderlist.vue?vue&type=script&lang=js"
export * from "./cloundorderlist.vue?vue&type=script&lang=js"
import style0 from "./cloundorderlist.vue?vue&type=style&index=0&id=49585bc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49585bc0",
  null
  
)

export default component.exports